import { useEffect, useRef, useState } from 'react';
import './Root.scss';
import NavBar from './components/MenuLeft/NavBar';
import NavBanner from './components/MenuLeft/NavBanner';
import PlayList from './components/MenuLeft/NavBarPlayList/PlayList';
import Top from './components/MenuRight/Top/Top';
import NowPlayingBar from './components/MenuRight/Bottom/NowPlayingBar';
import HomePage from './components/Pages/HomePage';
import PlayListPage from './components/Pages/PlayListPage';
import ReactPlayer from 'react-player';
import { useDataLayerValue } from './DataLayer';
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import firebase from 'firebase';
import { db } from './firebase';
import { GET_RANDOM_INT } from './constants/format';
import Tracks from './components/Pages/collection/Tracks';
import LoadingHome from './components/Pages/LoadingHome';
import Genre from './components/Pages/Genre';
import Song from './components/Pages/Song';
import Error404 from './components/Pages/Error404';
import Search from './components/Pages/Search';
import MenuAction from './components/MenuMobile/MenuAction';
import NowPlayingBarMobile from './components/MenuRight/Bottom/NowPlayingBarMobile';
import PlayingMobile from './components/Pages/PlayingMobile';
import MetaDocument from './MetaDocument';
import FormAddSong from './components/Pages/from/FormAddSong';
import FormAddPlaylist from './components/Pages/from/FormAddPlaylist';



function App() {

  const [{ user, lang, playing, playing_loading, song_playing, time_playing, volume, loop, playlists, shuffle, playing_song_by_id, seek_to, noti, playback_rate }, dispatch] = useDataLayerValue();
  const refPlayer = useRef(0);
  //const history = createMemoryHistory();
  const [loadingPage, setLoadingPage] = useState(true);
  const [showNoti, setShowNoti] = useState(false);
  const [meta, setMetaDocument] = useState({});

  let navigator = window.navigator;
  let MediaMetadata = window.MediaMetadata;

  useEffect(() => {
    if (noti !== '') {
      setShowNoti(true);
      setTimeout(() => { setShowNoti(false); }, 3000);
    }
    return () => { clearTimeout(); }
  }, [noti]);

  useEffect(() => {
    const loading = setTimeout(() => {
      setLoadingPage(false);
    }, 2000);

    return () => {
      clearTimeout(loading);
    };
  }, []);

  //Begin::Custom player music control google  

  useEffect(() => {
    navigator.mediaSession.setActionHandler('play', handleOnPlay());
    navigator.mediaSession.setActionHandler('pause', handleOnPause());

  }, [])

  useEffect(() => {
    let metaDocumentNew = { ...song_playing };
    setMetaDocument(metaDocumentNew);
    if ('mediaSession' in navigator) {
      navigator.mediaSession.metadata = new MediaMetadata({
        title: lang == 'en' ? metaDocumentNew.name_en : metaDocumentNew.name_vi,
        artist: metaDocumentNew.singer && metaDocumentNew.singer.trim() !== "" ? metaDocumentNew.singer : 'Singer',
        // album: 'Whenever You Need Somebody',
        artwork: [
          { src: `${metaDocumentNew.avatar ? metaDocumentNew.avatar : 'https://spotify-c4216.web.app/images/logo/safe_bg.jpg'}`, sizes: '96x96', type: 'image/png' },
          { src: `${metaDocumentNew.avatar ? metaDocumentNew.avatar : 'https://spotify-c4216.web.app/images/logo/safe_bg.jpg'}`, sizes: '128x128', type: 'image/png' },
          { src: `${metaDocumentNew.avatar ? metaDocumentNew.avatar : 'https://spotify-c4216.web.app/images/logo/safe_bg.jpg'}`, sizes: '192x192', type: 'image/png' },
          { src: `${metaDocumentNew.avatar ? metaDocumentNew.avatar : 'https://spotify-c4216.web.app/images/logo/safe_bg.jpg'}`, sizes: '256x256', type: 'image/png' },
          { src: `${metaDocumentNew.avatar ? metaDocumentNew.avatar : 'https://spotify-c4216.web.app/images/logo/safe_bg.jpg'}`, sizes: '384x384', type: 'image/png' },
          { src: `${metaDocumentNew.avatar ? metaDocumentNew.avatar : 'https://spotify-c4216.web.app/images/logo/safe_bg.jpg'}`, sizes: '512x512', type: 'image/png' },
        ]
      });

      // navigator.mediaSession.setActionHandler('seekbackward', function() {});
      // navigator.mediaSession.setActionHandler('seekforward', function() {});
      navigator.mediaSession.setActionHandler('previoustrack', () => handlePlayingSongPreviousOrNext('previous'));
      navigator.mediaSession.setActionHandler('nexttrack', () => handlePlayingSongPreviousOrNext('next'));
    }

  }, [song_playing]);







  //End::Custom player music control google  


  //To change time playing song 
  useEffect(() => {
    if (seek_to) {
      refPlayer.current.seekTo(parseFloat(time_playing.playedSeconds));
      dispatch({
        type: 'SET_SEEK_TO',
        seek_to: false
      });
    }
  }, [seek_to]);
  //To playing to song by id_song
  useEffect(() => {
    // type playing in [ previous , next ]

    if (playing_song_by_id !== null && playing_song_by_id.trim() !== '') {
      const idSong = playing_song_by_id ? playing_song_by_id : '';
      db.collection("songs").doc(`${idSong}`)
        .get()
        .then(async function (doc) {
          if (doc.exists) {
            let updateSong = { ...doc.data(), id: doc.id };
            dispatch({
              type: 'SET_PLAYING',
              playing: true
            });
            dispatch({
              type: 'SET_SONG_PLAYING',
              song_playing: updateSong
            });
            //update view of song
            let docData = {
              view: parseInt(doc.data()['view']) + 1,
              updated_at: firebase.firestore.Timestamp.now(),
            };
            await db.collection("songs").doc(doc.id).update(docData);
          }
        })
        .catch(function (error) {
          console.log("Error getting detail detail song.");
        });

    }

  }, [playing_song_by_id]);

  useEffect(() => {
    window.onbeforeunload = confirmExit;

    function confirmExit() {
      if (user.user_uid) {
        db.collection("users").doc(user.user_uid).update({
          reducer: { ...time_playing, ...song_playing, ...volume },
          updated_at: firebase.firestore.Timestamp.now()
        });
      }
    }
  }, []);

  //To real time change time in SliderPlaying component 
  const handleProgressPlayer = (e) => {
    // console.log('handleProgressPlayer', time_playing)
    const timePlaying = {
      played: e.played * 1000,
      playedSeconds: e.playedSeconds,
      loaded: e.loaded * 1000,
      loadedSeconds: e.loadedSeconds,
    };
    //Loading when media played > loaded
    if (parseFloat(timePlaying.playedSeconds) >= parseFloat(timePlaying.loadedSeconds)) {
      dispatch({
        type: 'SET_PLAYING_LOADING',
        playing_loading: playing
      });
    } else if (playing && playing_loading && parseFloat(timePlaying.playedSeconds) < parseFloat(timePlaying.loadedSeconds)) {
      dispatch({
        type: 'SET_PLAYING_LOADING',
        playing_loading: false
      });
    } else if (!playing) {
      dispatch({
        type: 'SET_PLAYING_LOADING',
        playing_loading: false
      });
    }
    if (!seek_to) {
      dispatch({
        type: 'SET_TIME_PLAYING',
        time_playing: timePlaying
      });
    }

  };
  //When before to playing song
  const handleOnReady = (e) => {

    //
  };

  //When on start playing song 
  const handleOnStart = (e) => {
    if (!playing) {
      dispatch({
        type: 'SET_PLAYING',
        playing: true
      });
    }
    if (playing_loading) {
      dispatch({
        type: 'SET_PLAYING_LOADING',
        playing_loading: false
      });
    }

  };

  //When playing of song to end then play other song 
  const handleOnEnded = (e) => {
    if (loop === 1) {
      return;
    }
    if (playlists.length > 0) {
      dispatch({
        type: 'SET_PLAYING_LOADING',
        playing_loading: true
      });
      const indexShuffle = GET_RANDOM_INT(playlists.length);
      const indexSongNow = playlists.indexOf(song_playing.id);
      const indexSongNext = shuffle && indexShuffle !== indexSongNow ? indexShuffle : indexSongNow + 1;
      const idSong = (playlists[indexSongNext] !== undefined && playlists[indexSongNext] !== null ? playlists[indexSongNext] : playlists[0]);
      db.collection("songs").doc(`${idSong}`)
        .get()
        .then(async function (doc) {
          if (doc.exists) {
            let updateSong = { ...doc.data(), id: doc.id };
            dispatch({
              type: 'SET_SONG_PLAYING',
              song_playing: updateSong
            });
            dispatch({
              type: 'SET_PLAYING',
              playing: true
            });

            //update view of song
            let docData = {
              view: doc.data()['view'] + 1,
              updated_at: firebase.firestore.Timestamp.now(),
            };
            await db.collection("songs").doc(doc.id).update(docData);

          }
        })
        .catch(function (error) {
          console.log("Error getting detail detail song.");
        });

    } else {
      dispatch({
        type: 'SET_PLAYING',
        playing: false
      });

    }

  };

  //When Pause play song 
  const handleOnPause = (e) => {
    if (playing) {
      dispatch({
        type: 'SET_PLAYING',
        playing: false
      });
    }
  };

  //When Play song
  const handleOnPlay = (e) => {
    if (!playing) {
      dispatch({
        type: 'SET_PLAYING',
        playing: true
      });
    }
    if (playing_loading) {
      dispatch({
        type: 'SET_PLAYING_LOADING',
        playing_loading: false
      });
    }
  };


  //Next or Previous play to song 
  const handlePlayingSongPreviousOrNext = (typeAction) => {
    const arrAction = ['previous', 'next'];
    if (!arrAction.includes(typeAction)) { return; }
    const indexSongNow = playlists.indexOf(song_playing.id);
    const indexSongNext = typeAction === 'previous' ? (indexSongNow - 1) : (indexSongNow + 1);
    const idSong = (playlists[indexSongNext] !== undefined && playlists[indexSongNext] !== null ? playlists[indexSongNext] : playlists[indexSongNow]);
    if (idSong) {
      dispatch({
        type: 'SET_PLAYING_LOADING',
        playing_loading: true
      });
      dispatch({
        type: 'SET_PLAYING_SONG_BY_ID',
        playing_song_by_id: idSong
      });

    }
  };



  return (
    <div className="Root">
      <MetaDocument title={`${lang == 'en' ? meta.name_en : meta.name_vi}`} subTitle={`${meta.singer ? meta.singer : ''}`} description={`${lang == 'en' ? meta.subtitle_en : meta.subtitle_vi}`} color={meta.bg_color} image={meta.avatar} />
      <Router >
        {window.innerWidth > 600 &&
          <div className="Root__left-container">
            <NavBanner />
            <NavBar />
            <PlayList />
          </div>}
        <div className={`Root__right-container ${(song_playing.id && window.innerWidth <= 600) ? "" : 'margin-is-detail-playing-mobile'}`}>
          <div className="Root__right-container__top top--bg-fixed">
            <Top />
          </div>
          <Switch>
            <Route exact path="/">
              <HomePage />
            </Route>
            <Route exact path="/playlist/:id">
              <PlayListPage />
            </Route>
            <Route exact path="/song/:id">
              {window.innerWidth <= 600 ? <PlayingMobile /> : <Song />}
            </Route>
            <Route exact path="/genre/:id">
              <Genre />
            </Route>
            <Route exact path="/collection/tracks">
              <Tracks />
            </Route>
            <Route exact path="/search">
              <Search />
            </Route>
            <Route exact path="/add-song">
              <FormAddSong />
            </Route>
            <Route exact path="/add-playlist">
              <FormAddPlaylist />
            </Route>
            <Route exact path="/error">
              <Error404 />
            </Route>
          </Switch>
        </div>
        <div className={`Root__noti ${showNoti ? 'noti-active' : ''}`}> <span>{noti ? noti : ''}</span> </div>
        {song_playing.id && (window.innerWidth <= 600 ? (<div className="Root__bottom-container-moblie"><NowPlayingBarMobile /></div>) : (<div className="Root__bottom-container"><NowPlayingBar /></div>))}
        {window.innerWidth <= 600 && <div className="Root__menu-mobile"><MenuAction /></div>}
        <div className="Root__bottom-player" >
          <ReactPlayer ref={refPlayer} controls={false} playing={playing} playbackRate={playback_rate} muted={volume === 0 ? true : false} onPlay={handleOnPlay} onPause={handleOnPause} loop={(loop === 1 ? true : false)} volume={volume} onEnded={handleOnEnded} onReady={handleOnReady} onStart={handleOnStart} onProgress={(e) => handleProgressPlayer(e)} url={song_playing.url_audio ? song_playing.url_audio : ''} />
        </div>
        <LoadingHome loadingPage={loadingPage} />

      </Router>
    </div>
  );
}

export default App;
